import { landingRouteMapper } from "../constants";

export const getLandingPathByCompanyId = (
  companyId: number,
): string | undefined => {
  const landingItem = landingRouteMapper.find(x => x.companyId === companyId);
  return landingItem?.path;
};

export const getLandingCompanyIdByPath = (path: string): number | undefined => {
  if (!path) {
    return undefined;
  }

  const landingItem = landingRouteMapper.find(
    x => x.path === path.toLowerCase(),
  );
  return landingItem?.companyId;
};
